import React, { useState } from 'react';
import { skills } from '../data/portfolio';
import { Skill } from '../types';
import './scss/Skills.scss';

const Skills: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'frontend', label: 'Frontend' },
    { id: 'backend', label: 'Backend' },
    { id: 'cloud', label: 'Cloud' },
    { id: 'database', label: 'Database' },
    { id: 'tools', label: 'Tools' }
  ];

  const filteredSkills = activeCategory === 'all' 
    ? skills 
    : skills.filter(skill => skill.category === activeCategory);

  const getSkillsByCategory = (category: string): Skill[] => {
    return skills.filter(skill => skill.category === category);
  };

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">Skills & Technologies</h2>
        
        <div className="skills-filter">
          {categories.map(category => (
            <button
              key={category.id}
              className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="skills-grid">
          {filteredSkills.map(skill => (
            <div key={skill.id} className="skill-card">
              <div className="skill-icon">
                <i className={skill.icon}></i>
              </div>
              <span className="skill-name">{skill.name}</span>
            </div>
          ))}
        </div>

        <div className="skills-categories">
          <div className="categories-grid">
            {categories.slice(1).map(category => {
              const categorySkills = getSkillsByCategory(category.id);
              return (
                <div key={category.id} className="category-section">
                  <h3 className="category-title">{category.label}</h3>
                  <div className="category-skills">
                    {categorySkills.map(skill => (
                      <div key={skill.id} className="category-skill">
                        <i className={skill.icon}></i>
                        <span>{skill.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
